import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import './ButtonGroup.css'
import useWindowSize from '../../../hooks/useWindowSize'

import { getProductLimit } from '../../../Helpers/index'

export const isAddButtonDisabled = (item, items, limit) => {
  const foundItem = items.find((i) => i.sku === item.sku)
  if (!foundItem) return false
  return foundItem.quantity >= limit
}

export const renderQuantity = (q, hit) => {
  const soldByWeight = hit?.attributes?.soldByWeight

  if (soldByWeight === 'true') {
    const defaultQuantity = hit?.attributes?.defaultQuantity
    const kg = q * defaultQuantity

    const parts = kg.toString().split('.')
    const decimals = parts[1] ? parts[1].length : 0

    if (decimals === 2) {
      return q < 100 ? kg + 'kg' : '+50kg'
    }

    return q < 100 ? kg.toFixed(1) + 'kg' : '+50kg'
  }

  return q < 100 ? q : '+99'
}

const ButtonGroup = ({ onAddToCart, onRemoveOneFromCart, hit, productQuantity, colorUnit }) => {
  const { isMobile } = useWindowSize()
  const { limit } = useSelector((s) => s.campaignConfigReducer.goToPayMessageConfig.digitLimitToCarryConfig)
  const productLimit = getProductLimit(hit.max, limit)

  const { shoppingCart: items } = useSelector((s) => s.shoppingCartReducer)
  const handleAdd = () => onAddToCart(hit)
  const handleRemove = () => onRemoveOneFromCart(hit)

  const mainCssClass = isMobile ? 'm-auto' : ''
  const quantityDisplayStyle = isMobile
    ? {
        width: '230px',
        backgroundColor: '#fff',
        color: colorUnit,
      }
    : { width: '200px', backgroundColor: '#fff', color: colorUnit }
  return (
    <div id="addProductToCart" className={`product-detail-page__button-groups ${mainCssClass} d-flex`}>
      <button type="button" onClick={handleRemove} data-testid="minus-sign-button">
        <i className="zmdi zmdi-minus" />
      </button>
      <div className="product-detail-page__button-groups__quantity" style={quantityDisplayStyle}>
        {renderQuantity(productQuantity, hit)}
      </div>
      <button
        disabled={isAddButtonDisabled(hit, items, productLimit)}
        type="button"
        onClick={handleAdd}
        data-testid="plus-sign-button"
      >
        <i className="zmdi zmdi-plus" />
      </button>
    </div>
  )
}

ButtonGroup.propTypes = {
  onAddToCart: PropTypes.func.isRequired,
  onRemoveOneFromCart: PropTypes.func.isRequired,
  productQuantity: PropTypes.number.isRequired,
  hit: PropTypes.object.isRequired,
  colorUnit: PropTypes.any.isRequired,
}

export default ButtonGroup
